require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/es7.symbol.async-iterator.js
// module id = 377
// module chunks = 1